import { css } from '@emotion/react'

export const pointerCursor = css`
  cursor: pointer;
`

export const center = css`
  display: flex;
  justify-content: center;
  align-items: center;
`
